import { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/i18n";

/** Opent de app in de taal van de aangemelde medewerker, tenzij hij zelf een taal koos. */
export default function LangSync() {
  const { user } = useAuth();
  const { lang, changeLang } = useLang();

  useEffect(() => {
    if (!user || user === false) return;
    if (localStorage.getItem("cb_lang_manual")) return;
    const mine = user.language;
    if (mine && mine !== lang) changeLang(mine, false);
  }, [user, lang, changeLang]);

  return null;
}
